// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNav1 > div::-webkit-scrollbar {
  display: none;
}

.logo-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper-text-box {
  display: flex;
  align-items: center;
  height: 50px;
  border-radius: 7px;
  transform: translateX(-1.5px);
  cursor: pointer;
}

.cashier-wrapper-box {
  font-weight: 500 !important;
  cursor: pointer;
}

.name-avatar-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: var(--surface-g1);
}

.wrapper-logo-image {
  width: 50px !important;
  height: 50px !important;
  border: 1px solid lightgray;
  border-radius: 7px;
  object-fit: cover;
}

.homewrapper-box {
  display: flex;
  align-items: center;
  gap: 20px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* ════════════════════════════════════════════════════════
   TOP NAVBAR  –  Figma-matched design (3-column layout)
   ════════════════════════════════════════════════════════ */

.topbar-brand-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 16px;
  height: 56px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;
  gap: 12px;
  flex-shrink: 0;
}

.topbar-brand-row.dark {
  background: #1e2235;
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

/* ── LEFT: brand ── */
.topbar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  justify-self: start;
}

.topbar-logo-wrap {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.topbar-brand-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 8px;
}

.topbar-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.5;
}

.topbar-brand-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.topbar-brand-row.dark .topbar-brand-name {
  color: #f9fafb;
}

.topbar-brand-sub {
  font-size: 10px;
  font-weight: 500;
  color: #65758b;
  letter-spacing: 0.02em;
  white-space: nowrap;
  text-transform: uppercase;
}

/* ── CENTER: notification chip OR page title ── */
.topbar-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  justify-self: center;
}

/* Dynamic island wrapper (chip + live-updates dropdown) */
.topbar-island {
  position: relative;
  display: inline-block;
}

/* Order Ready chip */
.topbar-notif-chip {
  background: #111827;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  width: 260px;
  height: 36px;
  padding: 4px 6px 4px 6px;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  gap: 8px;
  transition: background 0.15s;
}

.topbar-notif-chip:hover {
  background: #1f2937;
}

.topbar-notif-left {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.topbar-notif-icon-wrap {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.topbar-brand-row.dark .topbar-notif-chip {
  background: #111827;
}

@keyframes notifSlideUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes notifSlideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
}

.topbar-notif-text {
  font-size: 0.8rem;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-slide-in {
  animation: notifSlideUp 0.3s ease forwards;
}

.notif-slide-out {
  animation: notifSlideOut 0.3s ease forwards;
}

.topbar-brand-row.dark .topbar-notif-text {
  color: #ffffff;
}

.topbar-notif-badge {
  background: #ef4444;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  flex-shrink: 0;
}

.topbar-brand-row.dark .topbar-notif-badge {
  background: #ef4444;
  color: #ffffff;
}

/* ── Apple-style dynamic island (single morphing shell) ───────────────────── */
.island-shell {
  width: 260px;
  background: rgba(15, 23, 42, 0.95);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  box-shadow: 0 6px 20px rgba(2, 6, 23, 0.35);
  overflow: hidden;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* Single smooth iOS-style easing shared by every morphing property */
  transition:
    width 0.4s cubic-bezier(0.32, 0.72, 0, 1),
    border-radius 0.4s cubic-bezier(0.32, 0.72, 0, 1),
    box-shadow 0.4s ease;
  will-change: width, border-radius;
  z-index: 1300;
}

.island-shell.expanded {
  width: 360px;
  border-radius: 22px;
  box-shadow: 0 20px 55px rgba(2, 6, 23, 0.6);
}

/* Reserve the collapsed footprint so siblings don't shift when it expands */
.topbar-island {
  width: 260px;
  height: 44px;
}

/* ── Collapsed pill row ── */
.island-compact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 4px 6px 4px 8px;
  gap: 8px;
  opacity: 1;
  transition:
    height 0.4s cubic-bezier(0.32, 0.72, 0, 1),
    opacity 0.2s ease,
    padding 0.4s cubic-bezier(0.32, 0.72, 0, 1);
}

.island-shell.expanded .island-compact {
  height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
  pointer-events: none;
}

.island-compact-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;
}

.island-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.island-glyph-sm {
  width: 15px;
  height: 15px;
}

.island-glyph-md {
  width: 17px;
  height: 17px;
}

.island-compact-label {
  font-size: 0.78rem;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.island-badge-circle {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.island-badge-num {
  font-size: 0.62rem;
  font-weight: 700;
  color: #ffffff;
}

.island-badge-dot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
}

.island-shell.kitchen-arrival .island-compact {
  animation: kitchenPillCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.island-shell.kitchen-arrival .island-badge-dot {
  animation: kitchenArrivalCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes kitchenPillCue {
  0% {
    transform: scale(1);
  }
  36% {
    transform: scale(1.012);
  }
  100% {
    transform: scale(1);
  }
}

/* One brief arrival cue: no ambient pulse, and no repeat on ordinary refreshes. */
.island-shell.kitchen-arrival .island-icon,
.island-shell.kitchen-arrival .island-badge-circle {
  animation: kitchenArrivalCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes kitchenArrivalCue {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  36% {
    transform: scale(1.11);
    opacity: 0.88;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.kitchen-sound-prompt,
.kitchen-feed-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 10px;
  margin: 0 0 8px;
  border-radius: 10px;
  font-size: 0.72rem;
  line-height: 1.35;
}

.kitchen-sound-prompt {
  color: #f4d6a8;
  background: rgba(173, 100, 23, 0.18);
  border: 1px solid rgba(240, 165, 74, 0.28);
}

.kitchen-feed-error {
  color: #ffd1c9;
  background: rgba(185, 58, 43, 0.18);
  border: 1px solid rgba(255, 133, 115, 0.28);
}

.kitchen-sound-prompt button,
.kitchen-feed-error button {
  flex: 0 0 auto;
  border: 0;
  border-radius: 7px;
  padding: 5px 8px;
  color: #18202b;
  background: #f2c487;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.kitchen-feed-error button {
  background: #ffd1c9;
}

@media (prefers-reduced-motion: reduce) {
  .island-shell.kitchen-arrival .island-icon,
  .island-shell.kitchen-arrival .island-badge-circle,
  .island-shell.kitchen-arrival .island-badge-dot,
  .island-shell.kitchen-arrival .island-compact {
    animation: none;
  }
}

@keyframes islandPulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(1.3);
  }
}

/* ── Expandable area (grid-rows trick for smooth auto-height morph) ── */
.island-expand-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s cubic-bezier(0.32, 0.72, 0, 1);
}

.island-shell.expanded .island-expand-wrap {
  grid-template-rows: 1fr;
}

.island-expand-inner {
  min-height: 0;
  overflow: hidden;
  padding: 0 14px;
  opacity: 0;
  transition:
    opacity 0.3s ease 0.08s,
    padding 0.4s cubic-bezier(0.32, 0.72, 0, 1);
}

.island-shell.expanded .island-expand-inner {
  padding: 14px;
  opacity: 1;
}

.island-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 2px;
}

.island-panel-title {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.island-panel-count {
  font-size: 0.65rem;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 2px 9px;
  font-weight: 600;
}

.island-panel-count b {
  font-weight: 700;
  margin-right: 3px;
}

.island-panel-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Keep the opened panel compact (~3 rows); scroll if there are more */
  max-height: 178px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
}

.island-panel-list::-webkit-scrollbar {
  width: 5px;
}

.island-panel-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 999px;
}

.island-panel-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 12px;
  cursor: pointer;
  transition:
    background 0.12s,
    opacity 0.12s;
}

.island-panel-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

/* Per-row unread indicator — hidden once the row is read */
.island-item-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3b82f6;
  flex-shrink: 0;
}

.island-item-dot.hidden {
  visibility: hidden;
}

/* Read rows are dimmed */
.island-panel-item.read {
  opacity: 0.5;
}

.island-panel-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.island-panel-content {
  flex: 1;
  min-width: 0;
}

.island-panel-item-title {
  font-size: 0.82rem;
  font-weight: 500;
  color: #f8fafc;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.island-panel-item-time {
  font-size: 0.65rem;
  color: #94a3b8;
  margin: 2px 0 0;
}

.island-panel-chevron-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 0.12s,
    color 0.12s;
}

.island-panel-chevron-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* Subtle page title chip (non-table-layout pages) */
.topbar-page-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  padding: 4px 14px;
  transition: background 0.15s;
}

.topbar-brand-row.dark .topbar-page-chip {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.1);
}

.topbar-page-chip-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0860e6;
  flex-shrink: 0;
}

.topbar-brand-row.dark .topbar-page-chip-dot {
  background: #60a5fa;
}

.topbar-page-chip-text {
  font-size: 0.78rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.topbar-brand-row.dark .topbar-page-chip-text {
  color: #d1d5db;
}

/* ── RIGHT: search + action buttons ── */
.topbar-right-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-self: end;
}

/* Theme toggle button — premium pill */
.topbar-theme-toggle-btn {
  width: 34px !important;
  height: 34px !important;
  border-radius: 10px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafc !important;
  color: #475569;
  box-shadow: 0 1px 3px rgba(15,23,42,0.07);
  transition: background 0.18s, color 0.18s, border-color 0.18s,
              box-shadow 0.18s, transform 0.22s cubic-bezier(.34,1.56,.64,1);
}

.topbar-theme-toggle-btn:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
  color: #1e293b;
  box-shadow: 0 2px 8px rgba(15,23,42,0.12);
  transform: rotate(15deg) scale(1.08);
}

.topbar-theme-toggle-btn:active {
  transform: scale(0.93);
}

.topbar-brand-row.dark .topbar-theme-toggle-btn {
  background: rgba(30,41,59,0.9) !important;
  border-color: rgba(71,85,105,0.6) !important;
  color: #e2e8f0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
}

.topbar-brand-row.dark .topbar-theme-toggle-btn:hover {
  background: rgba(51,65,85,0.9) !important;
  border-color: rgba(100,116,139,0.6) !important;
  color: #fbbf24;
  box-shadow: 0 2px 10px rgba(251,191,36,0.15);
  transform: rotate(15deg) scale(1.08);
}

/* Search icon button (Replit-style compact trigger) */
.topbar-search-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #64748b;
  flex-shrink: 0;
  transition:
    background 0.15s,
    color 0.15s;
}

.topbar-search-btn:hover,
.topbar-search-btn--active {
  background: #f1f5f9;
  color: #334155;
}

.topbar-brand-row.dark .topbar-search-btn {
  color: #9ca3af;
}

.topbar-brand-row.dark .topbar-search-btn:hover,
.topbar-brand-row.dark .topbar-search-btn--active {
  background: rgba(255, 255, 255, 0.08);
  color: #f9fafb;
}

/* Search drawer (opened from the icon button) — right-side panel below header */
.topbar-search-backdrop {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.28);
  z-index: 12999;
}

.topbar-search-drawer {
  position: fixed;
  top: 56px;
  right: 0;
  bottom: 0;
  width: 420px;
  max-width: 92vw;
  background: #ffffff;
  border-left: 1px solid #e5e7eb;
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.12);
  z-index: 13000;
  display: flex;
  flex-direction: column;
  animation: searchDrawerIn 0.22s ease;
}

@keyframes searchDrawerIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.topbar-search-drawer-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.topbar-search-wrap--modal {
  flex: 1;
  min-width: 0;
  height: 44px;
  border-radius: 9999px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  padding: 0 16px;
  gap: 10px;
}

.topbar-search-wrap--modal:focus-within {
  background: #ffffff;
  border-color: #0860e6;
  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);
}

.topbar-search-wrap--modal .topbar-search-icon {
  font-size: 1.2rem !important;
}

.topbar-search-wrap--modal .topbar-search-input {
  font-size: 0.9rem;
}

.topbar-search-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  color: #475569;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;
}

.topbar-search-close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.topbar-search-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.topbar-search-comingsoon {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 8px;
}

.topbar-search-comingsoon-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  padding: 4px 12px;
}

.topbar-search-comingsoon-text {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 500;
  color: #64748b;
}

/* Order History inline search popover (no dimming backdrop) */
.topbar-search-popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 110px;
  width: 340px;
  max-width: 80vw;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16);
  padding: 8px;
  z-index: 13000;
  animation: searchPopoverIn 0.16s ease;
}

@keyframes searchPopoverIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.topbar-search-wrap--popover {
  width: 100%;
  min-width: 0;
  height: 42px;
  border-radius: 9999px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  padding: 0 14px;
  gap: 10px;
}

.topbar-search-wrap--popover:focus-within {
  background: #ffffff;
  border-color: #0860e6;
  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);
}

.topbar-search-wrap--popover .topbar-search-icon {
  font-size: 1.2rem !important;
}

.topbar-search-wrap--popover .topbar-search-input {
  font-size: 0.9rem;
}

/* Search bar */
.topbar-search-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f6f8;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 0 10px;
  height: 36px;
  min-width: 220px;
  transition:
    border-color 0.15s,
    box-shadow 0.15s,
    background 0.15s;
}

.topbar-search-wrap:focus-within {
  background: #ffffff;
  border-color: #0860e6;
  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);
}

.topbar-brand-row.dark .topbar-search-wrap {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.08);
}

.topbar-brand-row.dark .topbar-search-wrap:focus-within {
  background: rgba(255, 255, 255, 0.1);
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.topbar-search-icon {
  color: #9ca3af !important;
  font-size: 1rem !important;
  flex-shrink: 0;
}

.topbar-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.8rem;
  font-weight: 500;
  color: #111827;
  width: 100%;
  font-family: inherit;
}

.topbar-brand-row.dark .topbar-search-input {
  color: #f9fafb;
}

.topbar-search-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.topbar-search-clear {
  color: #9ca3af !important;
  font-size: 1rem !important;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s;
}

.topbar-search-clear:hover {
  color: #374151 !important;
}

/* Notification bell */
.topbar-notif-bell-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid transparent;
  padding: 0;
  cursor: pointer;
  color: #64748b;
  background: transparent;
  transition:
    background 0.15s,
    color 0.15s;
  flex-shrink: 0;
}

.topbar-notif-bell-wrap:hover {
  background: #f1f5f9;
  color: #334155;
}

.topbar-brand-row.dark .topbar-notif-bell-wrap {
  color: #9ca3af;
}

.topbar-brand-row.dark .topbar-notif-bell-wrap:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #f9fafb;
}

.topbar-notif-bell-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ef4444;
  border: 2px solid #ffffff;
  pointer-events: none;
}

/* Action icon buttons */
.topbar-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  background: transparent;
  border: 1px solid transparent;
  transition:
    background 0.15s,
    color 0.15s,
    border-color 0.15s;
  flex-shrink: 0;
}

.topbar-action-btn:hover {
  background: #f5f6f8;
  color: #111827;
  border-color: #e5e7eb;
}

.topbar-brand-row.dark .topbar-action-btn {
  color: #9ca3af;
}

.topbar-brand-row.dark .topbar-action-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #f9fafb;
  border-color: rgba(255, 255, 255, 0.1);
}

.topbar-action-btn-active {
  background: #eff6ff !important;
  color: #1a56db !important;
  border-color: #bfdbfe !important;
}

.topbar-cash-drawer-btn {
  background: #fef9c3 !important;
  color: #854d0e !important;
  border-color: #fde68a !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
}

.topbar-cash-drawer-btn:hover {
  background: #fef08a !important;
}

.topbar-brand-row.dark .topbar-action-btn-active {
  background: rgba(59, 130, 246, 0.15) !important;
  color: #60a5fa !important;
  border-color: rgba(59, 130, 246, 0.3) !important;
}

/* Avatar button */
.topbar-avatar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  cursor: pointer;
  background: #1a56db;
  border: none;
  overflow: hidden;
  transition:
    box-shadow 0.15s,
    transform 0.15s;
  flex-shrink: 0;
}

.topbar-avatar-btn:hover {
  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.2);
  transform: scale(1.05);
}

.topbar-brand-row.dark .topbar-avatar-btn {
  background: #1d4ed8;
  border-color: #3b82f6;
}

.topbar-avatar-initials {
  font-size: 0.85rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
  user-select: none;
  letter-spacing: 0.02em;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .topbar-brand-row {
    grid-template-columns: auto 1fr auto;
    padding: 0 12px;
    gap: 8px;
  }
  .topbar-brand-sub {
    display: none;
  }
  .topbar-brand-name {
    font-size: 16px;
  }
  .topbar-search-wrap {
    min-width: 140px;
  }
  .topbar-notif-chip {
    width: 200px;
  }
  .topbar-action-tablet-hide {
    display: none;
  }
}

@media (max-width: 576px) {
  .topbar-brand-row {
    padding: 0 10px;
    grid-template-columns: auto auto auto;
    gap: 6px;
  }
  .topbar-brand-text {
    display: none;
  }
  .topbar-search-wrap {
    min-width: 100px;
  }
  .topbar-page-chip {
    display: none;
  }
  .topbar-notif-chip {
    width: 160px;
  }
  .topbar-action-desktop-only {
    display: none;
  }
}

@media (max-width: 480px) {
  .topbar-brand-row {
    padding: 0 8px;
    height: 52px;
    gap: 4px;
  }
  .topbar-logo-wrap {
    width: 30px;
    height: 30px;
  }
  .topbar-brand-logo {
    width: 32px;
    height: 32px;
  }
  .topbar-search-wrap {
    min-width: 80px;
  }
  /* Compact notif chip — icon + badge only, no text */
  .topbar-notif-chip {
    width: auto;
    min-width: 36px;
    height: 32px;
    padding: 4px 8px;
    gap: 4px;
  }
  .topbar-notif-text {
    display: none;
  }
  .topbar-notif-icon-wrap {
    width: 22px;
    height: 22px;
  }
  .topbar-notif-badge {
    font-size: 0.65rem;
    min-width: 16px;
    height: 16px;
  }
  .topbar-avatar-btn {
    width: 30px;
    height: 30px;
  }
  .topbar-avatar-initials {
    font-size: 0.75rem;
  }
  .topbar-action-btn {
    width: 30px;
    height: 30px;
    border-radius: 6px;
  }
}

/* ════════════════════════════════════════════════════════
   REST OF ORIGINAL STYLES (unchanged)
   ════════════════════════════════════════════════════════ */

@media (max-width: 576px) {
  .toolbar {
    margin: 0 0.5rem;
  }
}

.wrapper-input-box {
  width: 50%;
  margin: 0 1rem;
  padding: 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: lightgray;
  border-radius: 40px;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s ease;
}

@media (max-width: 576px) {
  .wrapper-input-box {
    margin: 0;
  }
}

.navbar-profile-pic {
  width: 2.3rem;
  height: 2.3rem;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.posNavbarIconBox {
  display: flex;
  margin-top: 0.5rem;
}

.icon-color {
  color: red !important;
}

.dark .wrapper-input-box {
  background: #353a50;
}

.wrapper-input-box:hover {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.backBtn-wrapper {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.search-icon {
  color: lightgray;
  font-size: 1.2rem;
  margin: 0 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.scan-icon {
  color: #2954a5;
  font-size: 1.6rem !important;
  margin-right: 0.5rem;
  cursor: pointer;
}

.dark .scan-icon {
  color: lightgray;
}

.search-loader {
  display: flex;
  margin: 0 0.5rem;
}

.search-input {
  border: none;
  background-color: transparent;
  width: 100%;
  font-size: 0.9rem;
}

.search-input-new-keyboard-page {
  border: none;
  background-color: transparent;
  width: 100%;
  font-size: 0.9rem;
}

.search-input-new-keyboard-page::placeholder {
  color: #999;
}

.search-input::placeholder {
  color: #999;
}

.scanner-image {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 2rem;
  box-shadow: inset 0 0 0px 2rem rgba(0, 0, 0, 0.5);
}

.dark .search-input {
  color: #fff !important;
}

.search-input:focus {
  outline: none;
}

.dark .search-input-new-keyboard-page {
  color: black !important;
}

.search-input-new-keyboard-page:focus {
  outline: none;
}

.clear-icon {
  color: black;
  font-size: 1.2rem;
  margin: 0 0.5rem;
  cursor: pointer;
}

.dark .clear-icon {
  color: #fff;
}

.wrapper-icons-container {
  display: flex;
  align-items: center;
}

.palleticon {
  width: 40px !important;
}

.posContainer {
  display: flex;
}

.access-mode-kds-content {
  padding: 64px 8px 74px;
  width: 100%;
}

.access-mode-kds-navbar .posnavbar-bottom-bar {
  padding-right: 88px;
}

.access-mode-kds-exit-btn {
  position: fixed;
  right: 8px;
  bottom: 10px;
  z-index: 1201;
  font-family: inherit;
  border: 0;
  background: transparent;
}

.access-mode-kds-content .kds-screen-layout {
  height: calc(100dvh - 138px);
}

.navbar-disabled-region .topbar-right-actions > .topbar-action-btn,
.navbar-disabled-region .topbar-theme-toggle-btn,
.navbar-disabled-region .topbar-notif-bell-wrap,
.navbar-disabled-region .topbar-avatar-btn,
.navbar-disabled-region .topbar-brand,
.navbar-disabled-region .topbar-center,
.navbar-disabled-region .posnavbar-bottom-bar-right {
  opacity: 0.5;
}

.navbar-disabled-region,
.navbar-disabled-region * {
  cursor: not-allowed !important;
}

.navbar-disabled-region [data-kds-navigation-enabled],
.navbar-disabled-region [data-kds-navigation-enabled] * {
  cursor: auto !important;
  opacity: 1;
}

.navbar-disabled-region button[data-kds-navigation-enabled],
.navbar-disabled-region [data-kds-navigation-enabled] button,
.navbar-disabled-region [data-kds-navigation-enabled] .topbar-search-clear {
  cursor: pointer !important;
}

.navbar-disabled-region [data-kds-navigation-enabled] input {
  cursor: text !important;
}

.posContainerPaddingBottom {
  padding-bottom: 64px;
}

@media (max-width: 576px) {
  .posContainer {
    flex-direction: column;
  }
}

.dark .posContainer {
  background-color: #2b2f42 !important;
}

.light .posContainer {
  background: #ffffff !important;
}

.posNavbar {
  justify-content: flex-end;
}

@media (max-width: 576px) {
  .posNavbar {
    justify-content: center;
  }

  .newpayment-posNabar {
    justify-content: center;
  }
}

.dark .newpayment-posNabar {
  background-color: #2b2f42 !important;
  box-shadow: none !important;
}

.light .newpayment-posNabar {
  background: #ffffff;
  color: black;
  box-shadow: none !important;
  z-index: 100;
}

.dark .posNavbar {
  background-color: #2b2f42 !important;
  box-shadow: none !important;
  z-index: 1200;
}

.light .posNavbar {
  background: #f5f5f5;
  color: black;
  box-shadow: none !important;
  z-index: 1200;
}

.dark .css-12i7wg6-MuiPaper-root-MuiDrawer-paper {
  background-color: #2b2f42;
  border: none;
}

.light .css-12i7wg6-MuiPaper-root-MuiDrawer-paper {
  background: #f5f5f5;
  border-right: none;
}

.sideNav1 {
  height: 100vh !important;
}

.line {
  margin: 1rem;
  opacity: 0.5;
}

.name-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px !important;
  background-color: #fff;
  border-radius: 7px;
  width: 40%;
  padding: 0 1rem;
}

.search-container-box {
  width: 100vw;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.sideList {
  background-color: #fff;
  border-radius: 7px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 80px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

@media (max-height: 566px) and (max-width: 576px) {
  .sideList {
    height: auto;
    margin-bottom: 1rem !important;
  }
}

@media (max-height: 637px) and (min-width: 577px) {
  .sideList {
    height: auto;
    margin-bottom: 1rem !important;
  }
}

.dark .sideList {
  color: #353a50 !important;
  background-color: #353a50 !important;
  border: none !important;
  box-shadow: none !important;
}

.MuiDrawer-root .MuiDrawer-docked .sideNav1 .css-320yd2-MuiDrawer-docked {
  background-color: rgb(239, 240, 241) !important;
}

.home-text-navbar {
  text-align: center;
  color: #414552;
}

.dark .home-text-navbar {
  text-align: center;
  color: white;
}

.css-10hburv-MuiTypography-root {
  font-size: 0.7em !important;
  font-weight: 600 !important;
  font-family: "Outfit", "Inter", sans-serif;
  letter-spacing: 0.1px !important;
}

.home-text-navbar-III {
  font-weight: 600 !important;
  text-align: center;
  color: red;
  font-size: 0.7em !important;
}

.home-text-navbar-IV {
  font-weight: 600 !important;
  text-align: center;
  color: green;
  font-size: 0.7em !important;
}

.dark .home-text-navbar-III {
  text-align: center;
  color: white;
}

.home-text-navbar-II {
  font-weight: 600 !important;
  text-align: center;
  color: #000;
}

.dark .home-text-navbar-I {
  color: #fff !important;
}

.css-320yd2-MuiDrawer-docked {
  width: 80px !important;
}

.dark .icon {
  color: #949494;
}

.light .icon {
  color: #949494;
}

.icon-active {
  color: #0860e6 !important;
}

.icon-active-dark {
  color: white !important;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.blinking {
  animation: blink 1s linear infinite;
}

.name-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em !important;
  font-weight: 600 !important;
}

.home-background-active {
  border-radius: var(--4, 0.25rem) !important;
  border: 2px solid var(--Blue-B0, #0860e6) !important;
  background-color: var(--Blue-B4, #d9f2ff) !important;
  margin: 10px !important;
}

.dark .home-background-active {
  background-color: #0562fb !important;
}

.power-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.user-active-box {
  display: flex;
  align-items: center;
  gap: 5px;
}

.user-active-image {
  width: 10px;
  height: 10px;
  object-fit: contain;
  display: flex;
  align-items: center;
}

.active-text {
  border: 1px solid lightgray;
  font-weight: 600;
  font-size: 0.7em;
  letter-spacing: 0.15em;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
}

.full-screen-wrapper {
  border-radius: 7px !important;
  border: 1px solid black !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  margin-bottom: 10px !important;
  gap: 10px !important;
  width: 100%;
  padding: 4px !important;
  cursor: pointer;
  color: black !important;
  font-weight: bold !important;
}

.dark .full-screen-wrapper {
  color: white !important;
  border: 1px solid rgb(255, 255, 255) !important;
}

.full-screen-wrapper:hover {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px;
}

.modal-description {
  font-weight: bold !important;
  font-size: 1em !important;
  cursor: pointer;
}

.user-modal-wrapper-box {
  border: none;
}

.user-modal-wrapper-box:focus {
  outline: none;
}

/* Profile Actions Modal */
.profile-actions-modal {
  gap: 2px !important;
  text-align: left !important;
  position: absolute !important;
  top: 60px !important;
  right: 20px !important;
  left: auto !important;
  bottom: auto !important;
  transform: none !important;
}

.profile-actions-header {
  font-size: 0.68rem !important;
  font-weight: 600 !important;
  color: #9ca3af !important;
  letter-spacing: 0.07em !important;
  text-transform: uppercase !important;
  padding: 4px 4px 10px 4px !important;
  width: 100%;
}

.profile-action-item {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 9px 8px !important;
  border-radius: 10px !important;
  cursor: pointer !important;
  width: 100% !important;
  border: none !important;
  transition: background-color 0.15s ease !important;
}

.profile-action-item:hover {
  background-color: #f3f4f6 !important;
  box-shadow: none !important;
}

.dark .profile-action-item:hover {
  background-color: rgba(255, 255, 255, 0.07) !important;
}

.profile-action-icon-wrap {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
}

.profile-action-icon-wrap-title {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.dark .profile-action-icon-wrap {
  background-color: rgba(255, 255, 255, 0.1);
}

.profile-action-icon-wrap.logout {
  background-color: #fde8e8;
}

.profile-action-item-title {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  color: #111827 !important;
}

.dark .profile-action-item-title {
  color: #f9fafb !important;
}

.profile-action-item-subtitle {
  font-size: 0.72rem !important;
  font-weight: 400 !important;
  color: #6b7280 !important;
  line-height: 1.35 !important;
  margin-top: 1px;
}

.dark .profile-action-item-subtitle {
  color: #9ca3af !important;
}

.icon-off {
  color: red !important;
}

.dark .home-text-navbar-III {
  color: red !important;
}

.icon-on {
  color: green !important;
}

.customerDiv:disabled {
  background-color: #dddddd !important;
  border: 1px solid lightgray;
  color: darkgray !important;
  cursor: not-allowed !important;
}

.click-me-text {
  color: #2954a5 !important;
  font-weight: 600 !important;
  font-size: 28px !important;
}

.hide-me-btn {
  width: 0px;
  height: 0px;
  border: none;
  background-color: transparent;
}

.hide-me-btn:focus {
  outline: none;
}

.text-in-modal {
  text-align: center !important;
  font-size: 28px !important;
  font-weight: bold !important;
  color: red !important;
  border-radius: 10px !important;
}

.error-img-barcode {
  width: 70px !important;
  height: 70px !important;
  background-color: red !important;
}

.modal-main-wrapper-shortcut {
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  background-color: #f9fafb !important;
  border: 1px solid #e5e7eb;
  z-index: 10000;
  width: 90%;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1rem 1rem 0 1rem;
}

.dark .modal-main-wrapper-shortcut {
  background-color: #353a50 !important;
}

.close-icon-wrapper-modal {
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.shortcuts-close-icon {
  cursor: pointer;
  border-radius: 50%;
}

.shortcuts-close-icon:hover {
  background-color: #2954a5;
  color: #fff;
}

.modal-popup .MuiBackdrop-root {
  backdrop-filter: blur(5px);
}

.backdrop-pos {
  color: var(--blue);
  z-index: 1203;
  backdrop-filter: blur(5px);
  background-color: rgb(255 255 255 / 0%) !important;
}

.delivery-tab-status {
  color: lightgray !important;
}

.full-screen-wrapper:focus {
  background-color: #007bff64 !important;
  opacity: 0.8;
  border: 2px solid #007bff;
  border-radius: 5px;
  transition:
    background-color 0.3s ease,
    opacity 0.3s ease,
    border-color 0.3s ease;
  outline: none;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blinking::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 70%;
  height: 100%;
  margin-left: 15%;
  border-radius: 4px;
  background-color: rgba(255, 165, 0, 0.5);
  animation: blink 1.5s ease-in-out infinite;
  pointer-events: none;
}

.new-pos-header {
  background-color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 1rem;
  margin-top: 1rem;
  padding: 10px;
  border-radius: 0.5rem;
}

.new-pos-header.dark {
  background-color: var(--dark-blue);
}

.pos-header-text {
  color: #333;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
}

.pos-header-text.dark {
  color: var(--surface-white);
}

.common-search-bar-2 {
  width: 60%;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #f5f5f5 !important;
  padding: 0 5px;
  border-radius: 0.5rem;
  border: none;
}

.common-search-bar-2.dark {
  background-color: var(--dark-blue) !important;
  border: 1px solid var(--dark-background);
}

.normal-flex-searchbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 70%;
  gap: 1rem;
}

.mobile-normal-flex-searchbar {
  width: 100%;
}

.width-100 {
  width: 100%;
}

.new-mobile-searchbar-div {
  margin-top: 0.5rem;
}

.disableIcon {
  color: #e5e5e5 !important;
}

.new-pos-header-inner {
  display: flex;
  gap: 8px;
}

.commonSearchbarContainer {
  width: 50%;
}

/* ════════════════════════════════════════════════════════
   BOTTOM NAV BAR
   ════════════════════════════════════════════════════════ */

.posnavbar-bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-top: 1px solid #e9eaeb;
  padding: 0 8px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  height: 66px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

.dark .posnavbar-bottom-bar {
  background-color: #2b2f42;
  border-top-color: rgba(255, 255, 255, 0.1);
}

.posnavbar-bottom-bar-left {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
}

.posnavbar-bottom-bar-left::-webkit-scrollbar {
  display: none;
}

.posnavbar-bottom-bar-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding-left: 8px;
  border-left: 1px solid #e9eaeb;
}

.dark .posnavbar-bottom-bar-right {
  border-left-color: rgba(255, 255, 255, 0.1);
}

.posnavbar-cart-bar-portal {
  display: flex;
  align-items: stretch;
  min-width: 0;
}

.posnavbar-cart-bar-portal .cartGrossAndActionRow {
  flex: 1;
  border-top: none;
  background: transparent;
  padding: 0 8px;
}

.posnavbar-bottom-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  color: #717680;
  transition:
    background-color 0.15s,
    color 0.15s;
  min-width: 64px;
  flex-shrink: 0;
  gap: 4px;
}

.posnavbar-bottom-btn:hover {
  background-color: #f5f5f5;
  color: #252b37;
}

.posnavbar-bottom-btn:active {
  background-color: #eeeeee;
}

.posnavbar-bottom-btn-active {
  color: #0860e6 !important;
  background-color: #d9f2ff !important;
  border-radius: 10px;
}

.dark .posnavbar-bottom-btn {
  color: #949494;
}

.dark .posnavbar-bottom-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.dark .posnavbar-bottom-btn-active {
  color: #ffffff !important;
  background-color: #0562fb !important;
}

.posnavbar-bottom-btn-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
}

.posnavbar-notif-dot {
  position: absolute;
  top: -3px;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f44336;
  border: 1.5px solid #ffffff;
  animation: blink 1s linear infinite;
}

.dark .posnavbar-notif-dot {
  border-color: #2b2f42;
}

.posnavbar-bottom-btn-label {
  font-size: 10px;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  line-height: 1;
}

.posnavbar-bottom-btn-logout {
  color: #c62828;
}

.posnavbar-bottom-btn-logout:hover {
  background-color: #ffebee;
  color: #c62828;
}

.posnavbar-printer-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  gap: 2px;
}

.posnavbar-printer-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #717680;
}

.posnavbar-printer-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid white;
}

.posnavbar-printer-dot-online {
  background-color: #4caf50;
}

.posnavbar-printer-dot-offline {
  background-color: #f44336;
}

.posnavbar-printer-label-online {
  font-size: 10px;
  font-weight: 500;
  color: #2e7d32;
  white-space: nowrap;
}

.posnavbar-printer-label-offline {
  font-size: 10px;
  font-weight: 500;
  color: #c62828;
  white-space: nowrap;
}

/* ── No-session logout button (replaces weather widget) ── */
.posnavbar-logout-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  gap: 2px;
  cursor: pointer;
  color: #c62828;
  transition: background-color 0.15s;
}

.posnavbar-logout-btn:hover {
  background-color: #ffebee;
}

.posnavbar-logout-label {
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 1;
}

.dark .posnavbar-logout-btn {
  color: #ef9a9a;
}

.dark .posnavbar-logout-btn:hover {
  background-color: rgba(198, 40, 40, 0.15);
}

/* ── EDC machine status indicator ── */
.posnavbar-payment-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  color: inherit;
  cursor: default;
  flex-shrink: 0;
}

.posnavbar-wifi-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  color: inherit;
  cursor: default;
  flex-shrink: 0;
}

.posnavbar-payment-btn--clickable {
  cursor: pointer;
  transition: background 0.15s;
}
.posnavbar-payment-btn--clickable:hover { background: rgba(255,255,255,0.08); }

/* ── No Internet Overlay ── */
.net-offline-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: #0a0a0a;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: netFadeIn 0.35s ease;
}

@keyframes netFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.net-offline-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 400px;
  padding: 0 24px;
  animation: netSlideUp 0.4s cubic-bezier(.22,.61,.36,1);
}

@keyframes netSlideUp {
  from { transform: translateY(28px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

.net-offline-icon-ring {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #1a1a1a;
  border: 2px solid #2a2a2a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  box-shadow: 0 0 0 16px rgba(255,255,255,0.03);
}

.net-offline-title {
  font-size: 1.6rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 12px;
  letter-spacing: -0.01em;
}

.net-offline-sub {
  font-size: 0.92rem;
  color: #888;
  line-height: 1.6;
  margin: 0 0 24px;
}

.net-offline-pills {
  display: flex;
  gap: 10px;
  margin-bottom: 32px;
}

.net-offline-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid #2a2a2a;
  color: #aaa;
  font-size: 0.78rem;
  font-weight: 500;
  background: #141414;
}

.net-offline-retry {
  width: 100%;
  max-width: 240px;
  padding: 14px;
  border-radius: 6px;
  border: none;
  background: #e50914;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.03em;
  transition: background 0.15s, transform 0.1s;
  margin-bottom: 20px;
}
.net-offline-retry:hover  { background: #f40612; }
.net-offline-retry:active { transform: scale(0.97); }

.net-offline-footnote {
  font-size: 0.75rem;
  color: #555;
  margin: 0;
}

/* ── Slow Internet Toast ── */
.net-slow-toast {
  position: fixed;
  bottom: 80px;
  left: 20px;
  z-index: 99998;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #1c1400;
  border: 1px solid #f59e0b40;
  border-left: 3px solid #f59e0b;
  border-radius: 12px;
  padding: 14px 16px;
  min-width: 300px;
  max-width: 380px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.35);
  animation: netToastIn 0.4s cubic-bezier(.22,.61,.36,1);
}

@keyframes netToastIn {
  from { transform: translateX(-24px); opacity: 0; }
  to   { transform: translateX(0);     opacity: 1; }
}

.net-slow-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(245,158,11,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f59e0b;
  margin-top: 2px;
}

.net-slow-body {
  flex: 1;
  min-width: 0;
}

.net-slow-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.net-slow-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: #fbbf24;
}

.net-slow-speed {
  font-size: 0.75rem;
  font-weight: 600;
  color: #f59e0b;
  background: rgba(245,158,11,0.12);
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.net-slow-sub {
  font-size: 0.77rem;
  color: #a16207;
  line-height: 1.45;
  margin: 0 0 10px;
}
.dark .net-slow-sub { color: #92400e; }

.net-slow-progress-track {
  width: 100%;
  height: 3px;
  border-radius: 999px;
  background: rgba(245,158,11,0.15);
  overflow: hidden;
}

.net-slow-progress-bar {
  height: 100%;
  background: #f59e0b;
  border-radius: 999px;
  animation: netSlowProgress 8s linear forwards;
}

@keyframes netSlowProgress {
  from { width: 100%; }
  to   { width: 0%; }
}

.net-slow-close {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(245,158,11,0.12);
  color: #f59e0b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
  margin-top: 2px;
  padding: 0;
}
.net-slow-close:hover { background: rgba(245,158,11,0.22); }

/* ── EDC Mode Toggle Modal ── */
.edc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(3px);
}

.edc-modal-card {
  background: #ffffff;
  border-radius: 20px;
  width: 100%;
  max-width: 420px;
  padding: 28px;
  position: relative;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.22);
}

.dark .edc-modal-card {
  background: #1e293b;
  border: 1px solid #334155;
}

.edc-modal-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition: background 0.15s;
}
.edc-modal-close-btn:hover { background: #f1f5f9; }
.dark .edc-modal-close-btn { background: #334155; border-color: #475569; color: #94a3b8; }

.edc-modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-bottom: 24px;
}

.edc-modal-lock-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(96, 165, 250, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.edc-modal-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.dark .edc-modal-title { color: #f1f5f9; }

.edc-modal-subtitle {
  font-size: 0.82rem;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
}
.dark .edc-modal-subtitle { color: #94a3b8; }

.edc-modal-body form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edc-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edc-modal-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.dark .edc-modal-label { color: #94a3b8; }

.edc-modal-pin-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 4px 12px;
  background: #f8fafc;
}
.dark .edc-modal-pin-wrap {
  background: #0f172a;
  border-color: #334155;
}
.edc-modal-pin-wrap .MuiInput-root { width: 100%; }
.edc-modal-pin-wrap input { color: #1e293b; font-weight: 600; font-size: 0.95rem; }
.dark .edc-modal-pin-wrap input { color: #f1f5f9; }

.edc-modal-confirm-btn {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: none;
  background: #0f172a;
  color: #f8fafc;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  margin-top: 4px;
}
.edc-modal-confirm-btn:hover { background: #1e293b; }
.edc-modal-confirm-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.dark .edc-modal-confirm-btn { background: #3b82f6; }
.dark .edc-modal-confirm-btn:hover { background: #2563eb; }

.edc-modal-cancel-btn {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: transparent;
  color: #64748b;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.edc-modal-cancel-btn:hover { background: #f8fafc; }
.dark .edc-modal-cancel-btn { border-color: #334155; color: #94a3b8; }
.dark .edc-modal-cancel-btn:hover { background: #334155; }

/* ── Location / weather widget ── */
.posnavbar-location-widget {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  border-radius: 12px;
  border: none;
  background: #0f172a;
  color: #ffffff;
  cursor: pointer;
  flex-shrink: 0;
  transition:
    background 0.15s,
    border-color 0.15s;
  max-width: 160px;
}

.posnavbar-location-widget:hover {
  background: #1e293b;
}

.dark .posnavbar-location-widget {
  background: #0f172a;
}

.posnavbar-location-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.posnavbar-location-city {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .posnavbar-location-city {
  color: #d1d5db;
}

/* ── active state for stats icon button ── */
.topbar-action-btn--active {
  background: #eff6ff !important;
  color: #1a56db !important;
  border-color: #bfdbfe !important;
}

/* ════════════════════════════════════════
   Floor Capacity Popup
   ════════════════════════════════════════ */
.fcp-popup {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  width: 300px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 20px;
  z-index: 9999;
  border: 1px solid #f0f1f3;
}

.fcp-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.fcp-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fcp-label {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.fcp-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.fcp-pct-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #eff6ff;
  border: 1.5px solid #bfdbfe;
  border-radius: 10px;
  padding: 6px 12px;
  min-width: 60px;
}

.fcp-pct-now {
  font-size: 9px;
  font-weight: 700;
  color: #1a56db;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fcp-pct-value {
  font-size: 20px;
  font-weight: 800;
  color: #1a56db;
  line-height: 1.1;
}

.fcp-bar-track {
  width: 100%;
  height: 6px;
  background: #e5e7eb;
  border-radius: 99px;
  overflow: hidden;
  margin-bottom: 16px;
}

.fcp-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6 0%, #1a56db 100%);
  border-radius: 99px;
  transition: width 0.4s ease;
  min-width: 4px;
}

.fcp-stats-row {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.fcp-stat-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
}

.fcp-stat-label {
  font-size: 9px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.fcp-stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.1;
}

.fcp-toggle-row {
  display: flex;
  gap: 0;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 3px;
}

.fcp-toggle-btn {
  flex: 1;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s,
    box-shadow 0.15s;
}

.fcp-toggle-btn.active {
  background: #ffffff;
  color: #1a56db;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.fcp-toggle-btn:not(.active):hover {
  color: #374151;
}

/* Backdrop */
.Confirmation___modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

/* Modal Box */
.Confirmation___modal-container {
  width: 380px;
  background: #ffffff;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  animation: confirmationFadeIn 0.2s ease;
  text-align: center;
}

/* Title */
.Confirmation___modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 10px;
}

/* Text */
.Confirmation___modal-text {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
  line-height: 1.5;
}

/* Actions */
.Confirmation___modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

/* Buttons */
.Confirmation___modal-btn {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

/* Close Button */
.Confirmation___modal-btn-close {
  background: #f3f4f6;
  color: #374151;
}

.Confirmation___modal-btn-close:hover {
  background: #e5e7eb;
}

/* Primary Button */
.Confirmation___modal-btn-primary {
  background: #16a34a;
  color: #ffffff;
}

.Confirmation___modal-btn-primary:hover {
  background: #15803d;
}

/* Animation */
@keyframes confirmationFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ═══ DARK THEME — posnavbar additions ═══ */
.dark .home-text-navbar-II { color: #f1f5f9 !important; }

/* Floor-Capacity Popup */
.dark .fcp-popup {
  background: #1e293b;
  border-color: #334155;
  box-shadow: 0 8px 32px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3);
}
.dark .fcp-label  { color: #64748b; }
.dark .fcp-title  { color: #f1f5f9; }
.dark .fcp-pct-badge { background: rgba(42,113,255,0.15); border-color: #1e40af; }
.dark .fcp-pct-now   { color: #60a5fa; }
.dark .fcp-pct-value { color: #60a5fa; }
.dark .fcp-bar-track { background: #334155; }
.dark .fcp-stat-box  { background: #0f172a; border-color: #334155; }
.dark .fcp-stat-label { color: #64748b; }
.dark .fcp-stat-value { color: #f1f5f9; }
.dark .fcp-toggle-row { background: #0f172a; }
.dark .fcp-toggle-btn { color: #64748b; }
.dark .fcp-toggle-btn.active { background: #1e293b; color: #60a5fa; }
.dark .fcp-toggle-btn:not(.active):hover { color: #94a3b8; }

/* Confirmation modal */
.dark .Confirmation___modal-container {
  background: #1e293b;
  box-shadow: 0px 10px 30px rgba(0,0,0,0.5);
}
.dark .Confirmation___modal-title { color: #f1f5f9; }
.dark .Confirmation___modal-text  { color: #94a3b8; }
.dark .Confirmation___modal-btn-close {
  background: #334155;
  color: #e2e8f0;
}
.dark .Confirmation___modal-btn-close:hover { background: #475569; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,qEAAqE;EACrE;;;wBAGsB;EACtB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,4EAA4E;AAC5E;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,UAAU;EACV;;;+CAG6C;AAC/C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,kFAAkF;AAClF;;EAEE,sEAAsE;AACxE;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV;;+CAE6C;AAC/C;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sEAAsE;EACtE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf;;iBAEe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2DAA2D;AAC3D;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;eAEa;AACf;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;EACd,yCAAyC;EACzC;4EAC0E;AAC5E;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;EAC5C,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,cAAc;EACd,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd;;eAEa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB;;eAEa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B;;;sBAGoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB;;mBAEiB;EACjB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE;IACE,oCAAoC;IACpC,eAAe;IACf,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,qCAAqC;IACrC,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,QAAQ;EACV;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA,oDAAoD;EACpD;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;;6DAE6D;;AAE7D;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;EAGE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gEAAgE;EAChE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;EAChC;AACF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,oDAAoD;EACpD,oDAAoD;EACpD,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB;;;0BAGwB;EACxB,aAAa;AACf;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;eAEa;EACb,eAAe;EACf,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA,0CAA0C,kCAAkC,EAAE;;AAE9E,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;AACA,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,sBAAsB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,sDAAsD;AACxD;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,OAAO,wBAAwB,MAAM,UAAU,EAAE;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA,sBAAsB,cAAc,EAAE;;AAEtC;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,OAAO,WAAW,EAAE;EACpB,OAAO,SAAS,EAAE;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;AACA,wBAAwB,iCAAiC,EAAE;;AAE3D,gCAAgC;AAChC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEzF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,qCAAqC,WAAW,EAAE;AAClD,4BAA4B,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAClF,kCAAkC,cAAc,EAAE;;AAElD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA,+BAA+B,mBAAmB,EAAE;AACpD,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;AACrE,+BAA+B,mBAAmB,EAAE;AACpD,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,8BAA8B,mBAAmB,EAAE;AACnD,8BAA8B,qBAAqB,EAAE,cAAc,EAAE;AACrE,oCAAoC,mBAAmB,EAAE;;AAEzD,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd;;sBAEoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB;;iCAE+B;EAC/B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,6CAA6C;AAC7C,6BAA6B,yBAAyB,EAAE;;AAExD,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iEAAiE;AACnE;AACA,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,uBAAuB,iCAAiC,EAAE,qBAAqB,EAAE;AACjF,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE;AACnE,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,cAAc,EAAE;AACxC,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,2CAA2C,cAAc,EAAE;;AAE3D,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,cAAc,EAAE;AACpD;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA,8CAA8C,mBAAmB,EAAE","sourcesContent":[".sideNav1 > div::-webkit-scrollbar {\n  display: none;\n}\n\n.logo-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.wrapper-text-box {\n  display: flex;\n  align-items: center;\n  height: 50px;\n  border-radius: 7px;\n  transform: translateX(-1.5px);\n  cursor: pointer;\n}\n\n.cashier-wrapper-box {\n  font-weight: 500 !important;\n  cursor: pointer;\n}\n\n.name-avatar-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n  border-radius: 50%;\n  background-color: var(--surface-g1);\n}\n\n.wrapper-logo-image {\n  width: 50px !important;\n  height: 50px !important;\n  border: 1px solid lightgray;\n  border-radius: 7px;\n  object-fit: cover;\n}\n\n.homewrapper-box {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n/* ════════════════════════════════════════════════════════\n   TOP NAVBAR  –  Figma-matched design (3-column layout)\n   ════════════════════════════════════════════════════════ */\n\n.topbar-brand-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  padding: 0 16px;\n  height: 56px;\n  background: #ffffff;\n  border-bottom: 1px solid #e9eaeb;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.topbar-brand-row.dark {\n  background: #1e2235;\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n}\n\n/* ── LEFT: brand ── */\n.topbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  justify-self: start;\n}\n\n.topbar-logo-wrap {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.topbar-brand-logo {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.topbar-brand-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.5;\n}\n\n.topbar-brand-name {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n}\n\n.topbar-brand-row.dark .topbar-brand-name {\n  color: #f9fafb;\n}\n\n.topbar-brand-sub {\n  font-size: 10px;\n  font-weight: 500;\n  color: #65758b;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  text-transform: uppercase;\n}\n\n/* ── CENTER: notification chip OR page title ── */\n.topbar-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  justify-self: center;\n}\n\n/* Dynamic island wrapper (chip + live-updates dropdown) */\n.topbar-island {\n  position: relative;\n  display: inline-block;\n}\n\n/* Order Ready chip */\n.topbar-notif-chip {\n  background: #111827;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  display: flex;\n  width: 260px;\n  height: 36px;\n  padding: 4px 6px 4px 6px;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n  gap: 8px;\n  transition: background 0.15s;\n}\n\n.topbar-notif-chip:hover {\n  background: #1f2937;\n}\n\n.topbar-notif-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n\n.topbar-notif-icon-wrap {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #dcfce7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.topbar-brand-row.dark .topbar-notif-chip {\n  background: #111827;\n}\n\n@keyframes notifSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes notifSlideOut {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n}\n\n.topbar-notif-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notif-slide-in {\n  animation: notifSlideUp 0.3s ease forwards;\n}\n\n.notif-slide-out {\n  animation: notifSlideOut 0.3s ease forwards;\n}\n\n.topbar-brand-row.dark .topbar-notif-text {\n  color: #ffffff;\n}\n\n.topbar-notif-badge {\n  background: #ef4444;\n  color: #ffffff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  flex-shrink: 0;\n}\n\n.topbar-brand-row.dark .topbar-notif-badge {\n  background: #ef4444;\n  color: #ffffff;\n}\n\n/* ── Apple-style dynamic island (single morphing shell) ───────────────────── */\n.island-shell {\n  width: 260px;\n  background: rgba(15, 23, 42, 0.95);\n  -webkit-backdrop-filter: blur(12px);\n  backdrop-filter: blur(12px);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 999px;\n  box-shadow: 0 6px 20px rgba(2, 6, 23, 0.35);\n  overflow: hidden;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  /* Single smooth iOS-style easing shared by every morphing property */\n  transition:\n    width 0.4s cubic-bezier(0.32, 0.72, 0, 1),\n    border-radius 0.4s cubic-bezier(0.32, 0.72, 0, 1),\n    box-shadow 0.4s ease;\n  will-change: width, border-radius;\n  z-index: 1300;\n}\n\n.island-shell.expanded {\n  width: 360px;\n  border-radius: 22px;\n  box-shadow: 0 20px 55px rgba(2, 6, 23, 0.6);\n}\n\n/* Reserve the collapsed footprint so siblings don't shift when it expands */\n.topbar-island {\n  width: 260px;\n  height: 44px;\n}\n\n/* ── Collapsed pill row ── */\n.island-compact {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 44px;\n  padding: 4px 6px 4px 8px;\n  gap: 8px;\n  opacity: 1;\n  transition:\n    height 0.4s cubic-bezier(0.32, 0.72, 0, 1),\n    opacity 0.2s ease,\n    padding 0.4s cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.island-shell.expanded .island-compact {\n  height: 0;\n  opacity: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  pointer-events: none;\n}\n\n.island-compact-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 1;\n}\n\n.island-icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.island-glyph-sm {\n  width: 15px;\n  height: 15px;\n}\n\n.island-glyph-md {\n  width: 17px;\n  height: 17px;\n}\n\n.island-compact-label {\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.island-badge-circle {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.island-badge-num {\n  font-size: 0.62rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.island-badge-dot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #ef4444;\n}\n\n.island-shell.kitchen-arrival .island-compact {\n  animation: kitchenPillCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n.island-shell.kitchen-arrival .island-badge-dot {\n  animation: kitchenArrivalCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes kitchenPillCue {\n  0% {\n    transform: scale(1);\n  }\n  36% {\n    transform: scale(1.012);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* One brief arrival cue: no ambient pulse, and no repeat on ordinary refreshes. */\n.island-shell.kitchen-arrival .island-icon,\n.island-shell.kitchen-arrival .island-badge-circle {\n  animation: kitchenArrivalCue 760ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n\n@keyframes kitchenArrivalCue {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  36% {\n    transform: scale(1.11);\n    opacity: 0.88;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.kitchen-sound-prompt,\n.kitchen-feed-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 9px 10px;\n  margin: 0 0 8px;\n  border-radius: 10px;\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.kitchen-sound-prompt {\n  color: #f4d6a8;\n  background: rgba(173, 100, 23, 0.18);\n  border: 1px solid rgba(240, 165, 74, 0.28);\n}\n\n.kitchen-feed-error {\n  color: #ffd1c9;\n  background: rgba(185, 58, 43, 0.18);\n  border: 1px solid rgba(255, 133, 115, 0.28);\n}\n\n.kitchen-sound-prompt button,\n.kitchen-feed-error button {\n  flex: 0 0 auto;\n  border: 0;\n  border-radius: 7px;\n  padding: 5px 8px;\n  color: #18202b;\n  background: #f2c487;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.kitchen-feed-error button {\n  background: #ffd1c9;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .island-shell.kitchen-arrival .island-icon,\n  .island-shell.kitchen-arrival .island-badge-circle,\n  .island-shell.kitchen-arrival .island-badge-dot,\n  .island-shell.kitchen-arrival .island-compact {\n    animation: none;\n  }\n}\n\n@keyframes islandPulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.4;\n    transform: scale(1.3);\n  }\n}\n\n/* ── Expandable area (grid-rows trick for smooth auto-height morph) ── */\n.island-expand-wrap {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.4s cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.island-shell.expanded .island-expand-wrap {\n  grid-template-rows: 1fr;\n}\n\n.island-expand-inner {\n  min-height: 0;\n  overflow: hidden;\n  padding: 0 14px;\n  opacity: 0;\n  transition:\n    opacity 0.3s ease 0.08s,\n    padding 0.4s cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.island-shell.expanded .island-expand-inner {\n  padding: 14px;\n  opacity: 1;\n}\n\n.island-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding: 0 2px;\n}\n\n.island-panel-title {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.island-panel-count {\n  font-size: 0.65rem;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  padding: 2px 9px;\n  font-weight: 600;\n}\n\n.island-panel-count b {\n  font-weight: 700;\n  margin-right: 3px;\n}\n\n.island-panel-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  /* Keep the opened panel compact (~3 rows); scroll if there are more */\n  max-height: 178px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;\n}\n\n.island-panel-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.island-panel-list::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 999px;\n}\n\n.island-panel-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition:\n    background 0.12s,\n    opacity 0.12s;\n}\n\n.island-panel-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n/* Per-row unread indicator — hidden once the row is read */\n.island-item-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #3b82f6;\n  flex-shrink: 0;\n}\n\n.island-item-dot.hidden {\n  visibility: hidden;\n}\n\n/* Read rows are dimmed */\n.island-panel-item.read {\n  opacity: 0.5;\n}\n\n.island-panel-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.island-panel-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.island-panel-item-title {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: #f8fafc;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.island-panel-item-time {\n  font-size: 0.65rem;\n  color: #94a3b8;\n  margin: 2px 0 0;\n}\n\n.island-panel-chevron-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background 0.12s,\n    color 0.12s;\n}\n\n.island-panel-chevron-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n/* Subtle page title chip (non-table-layout pages) */\n.topbar-page-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  padding: 4px 14px;\n  transition: background 0.15s;\n}\n\n.topbar-brand-row.dark .topbar-page-chip {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.topbar-page-chip-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #0860e6;\n  flex-shrink: 0;\n}\n\n.topbar-brand-row.dark .topbar-page-chip-dot {\n  background: #60a5fa;\n}\n\n.topbar-page-chip-text {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.topbar-brand-row.dark .topbar-page-chip-text {\n  color: #d1d5db;\n}\n\n/* ── RIGHT: search + action buttons ── */\n.topbar-right-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  justify-self: end;\n}\n\n/* Theme toggle button — premium pill */\n.topbar-theme-toggle-btn {\n  width: 34px !important;\n  height: 34px !important;\n  border-radius: 10px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #f8fafc !important;\n  color: #475569;\n  box-shadow: 0 1px 3px rgba(15,23,42,0.07);\n  transition: background 0.18s, color 0.18s, border-color 0.18s,\n              box-shadow 0.18s, transform 0.22s cubic-bezier(.34,1.56,.64,1);\n}\n\n.topbar-theme-toggle-btn:hover {\n  background: #f1f5f9 !important;\n  border-color: #cbd5e1 !important;\n  color: #1e293b;\n  box-shadow: 0 2px 8px rgba(15,23,42,0.12);\n  transform: rotate(15deg) scale(1.08);\n}\n\n.topbar-theme-toggle-btn:active {\n  transform: scale(0.93);\n}\n\n.topbar-brand-row.dark .topbar-theme-toggle-btn {\n  background: rgba(30,41,59,0.9) !important;\n  border-color: rgba(71,85,105,0.6) !important;\n  color: #e2e8f0;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.3);\n}\n\n.topbar-brand-row.dark .topbar-theme-toggle-btn:hover {\n  background: rgba(51,65,85,0.9) !important;\n  border-color: rgba(100,116,139,0.6) !important;\n  color: #fbbf24;\n  box-shadow: 0 2px 10px rgba(251,191,36,0.15);\n  transform: rotate(15deg) scale(1.08);\n}\n\n/* Search icon button (Replit-style compact trigger) */\n.topbar-search-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #64748b;\n  flex-shrink: 0;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.topbar-search-btn:hover,\n.topbar-search-btn--active {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.topbar-brand-row.dark .topbar-search-btn {\n  color: #9ca3af;\n}\n\n.topbar-brand-row.dark .topbar-search-btn:hover,\n.topbar-brand-row.dark .topbar-search-btn--active {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f9fafb;\n}\n\n/* Search drawer (opened from the icon button) — right-side panel below header */\n.topbar-search-backdrop {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.28);\n  z-index: 12999;\n}\n\n.topbar-search-drawer {\n  position: fixed;\n  top: 56px;\n  right: 0;\n  bottom: 0;\n  width: 420px;\n  max-width: 92vw;\n  background: #ffffff;\n  border-left: 1px solid #e5e7eb;\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.12);\n  z-index: 13000;\n  display: flex;\n  flex-direction: column;\n  animation: searchDrawerIn 0.22s ease;\n}\n\n@keyframes searchDrawerIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.topbar-search-drawer-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.topbar-search-wrap--modal {\n  flex: 1;\n  min-width: 0;\n  height: 44px;\n  border-radius: 9999px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  padding: 0 16px;\n  gap: 10px;\n}\n\n.topbar-search-wrap--modal:focus-within {\n  background: #ffffff;\n  border-color: #0860e6;\n  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);\n}\n\n.topbar-search-wrap--modal .topbar-search-icon {\n  font-size: 1.2rem !important;\n}\n\n.topbar-search-wrap--modal .topbar-search-input {\n  font-size: 0.9rem;\n}\n\n.topbar-search-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #475569;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.topbar-search-close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.topbar-search-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar-search-comingsoon {\n  margin: auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n  padding: 8px;\n}\n\n.topbar-search-comingsoon-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #1d4ed8;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  padding: 4px 12px;\n}\n\n.topbar-search-comingsoon-text {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #64748b;\n}\n\n/* Order History inline search popover (no dimming backdrop) */\n.topbar-search-popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 110px;\n  width: 340px;\n  max-width: 80vw;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16);\n  padding: 8px;\n  z-index: 13000;\n  animation: searchPopoverIn 0.16s ease;\n}\n\n@keyframes searchPopoverIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.topbar-search-wrap--popover {\n  width: 100%;\n  min-width: 0;\n  height: 42px;\n  border-radius: 9999px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  padding: 0 14px;\n  gap: 10px;\n}\n\n.topbar-search-wrap--popover:focus-within {\n  background: #ffffff;\n  border-color: #0860e6;\n  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);\n}\n\n.topbar-search-wrap--popover .topbar-search-icon {\n  font-size: 1.2rem !important;\n}\n\n.topbar-search-wrap--popover .topbar-search-input {\n  font-size: 0.9rem;\n}\n\n/* Search bar */\n.topbar-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #f5f6f8;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  padding: 0 10px;\n  height: 36px;\n  min-width: 220px;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s,\n    background 0.15s;\n}\n\n.topbar-search-wrap:focus-within {\n  background: #ffffff;\n  border-color: #0860e6;\n  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.12);\n}\n\n.topbar-brand-row.dark .topbar-search-wrap {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.topbar-brand-row.dark .topbar-search-wrap:focus-within {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.topbar-search-icon {\n  color: #9ca3af !important;\n  font-size: 1rem !important;\n  flex-shrink: 0;\n}\n\n.topbar-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #111827;\n  width: 100%;\n  font-family: inherit;\n}\n\n.topbar-brand-row.dark .topbar-search-input {\n  color: #f9fafb;\n}\n\n.topbar-search-input::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.topbar-search-clear {\n  color: #9ca3af !important;\n  font-size: 1rem !important;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: color 0.15s;\n}\n\n.topbar-search-clear:hover {\n  color: #374151 !important;\n}\n\n/* Notification bell */\n.topbar-notif-bell-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  padding: 0;\n  cursor: pointer;\n  color: #64748b;\n  background: transparent;\n  transition:\n    background 0.15s,\n    color 0.15s;\n  flex-shrink: 0;\n}\n\n.topbar-notif-bell-wrap:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.topbar-brand-row.dark .topbar-notif-bell-wrap {\n  color: #9ca3af;\n}\n\n.topbar-brand-row.dark .topbar-notif-bell-wrap:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f9fafb;\n}\n\n.topbar-notif-bell-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #ef4444;\n  border: 2px solid #ffffff;\n  pointer-events: none;\n}\n\n/* Action icon buttons */\n.topbar-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #6b7280;\n  background: transparent;\n  border: 1px solid transparent;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    border-color 0.15s;\n  flex-shrink: 0;\n}\n\n.topbar-action-btn:hover {\n  background: #f5f6f8;\n  color: #111827;\n  border-color: #e5e7eb;\n}\n\n.topbar-brand-row.dark .topbar-action-btn {\n  color: #9ca3af;\n}\n\n.topbar-brand-row.dark .topbar-action-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f9fafb;\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.topbar-action-btn-active {\n  background: #eff6ff !important;\n  color: #1a56db !important;\n  border-color: #bfdbfe !important;\n}\n\n.topbar-cash-drawer-btn {\n  background: #fef9c3 !important;\n  color: #854d0e !important;\n  border-color: #fde68a !important;\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 50% !important;\n}\n\n.topbar-cash-drawer-btn:hover {\n  background: #fef08a !important;\n}\n\n.topbar-brand-row.dark .topbar-action-btn-active {\n  background: rgba(59, 130, 246, 0.15) !important;\n  color: #60a5fa !important;\n  border-color: rgba(59, 130, 246, 0.3) !important;\n}\n\n/* Avatar button */\n.topbar-avatar-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  cursor: pointer;\n  background: #1a56db;\n  border: none;\n  overflow: hidden;\n  transition:\n    box-shadow 0.15s,\n    transform 0.15s;\n  flex-shrink: 0;\n}\n\n.topbar-avatar-btn:hover {\n  box-shadow: 0 0 0 3px rgba(8, 96, 230, 0.2);\n  transform: scale(1.05);\n}\n\n.topbar-brand-row.dark .topbar-avatar-btn {\n  background: #1d4ed8;\n  border-color: #3b82f6;\n}\n\n.topbar-avatar-initials {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1;\n  user-select: none;\n  letter-spacing: 0.02em;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .topbar-brand-row {\n    grid-template-columns: auto 1fr auto;\n    padding: 0 12px;\n    gap: 8px;\n  }\n  .topbar-brand-sub {\n    display: none;\n  }\n  .topbar-brand-name {\n    font-size: 16px;\n  }\n  .topbar-search-wrap {\n    min-width: 140px;\n  }\n  .topbar-notif-chip {\n    width: 200px;\n  }\n  .topbar-action-tablet-hide {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .topbar-brand-row {\n    padding: 0 10px;\n    grid-template-columns: auto auto auto;\n    gap: 6px;\n  }\n  .topbar-brand-text {\n    display: none;\n  }\n  .topbar-search-wrap {\n    min-width: 100px;\n  }\n  .topbar-page-chip {\n    display: none;\n  }\n  .topbar-notif-chip {\n    width: 160px;\n  }\n  .topbar-action-desktop-only {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .topbar-brand-row {\n    padding: 0 8px;\n    height: 52px;\n    gap: 4px;\n  }\n  .topbar-logo-wrap {\n    width: 30px;\n    height: 30px;\n  }\n  .topbar-brand-logo {\n    width: 32px;\n    height: 32px;\n  }\n  .topbar-search-wrap {\n    min-width: 80px;\n  }\n  /* Compact notif chip — icon + badge only, no text */\n  .topbar-notif-chip {\n    width: auto;\n    min-width: 36px;\n    height: 32px;\n    padding: 4px 8px;\n    gap: 4px;\n  }\n  .topbar-notif-text {\n    display: none;\n  }\n  .topbar-notif-icon-wrap {\n    width: 22px;\n    height: 22px;\n  }\n  .topbar-notif-badge {\n    font-size: 0.65rem;\n    min-width: 16px;\n    height: 16px;\n  }\n  .topbar-avatar-btn {\n    width: 30px;\n    height: 30px;\n  }\n  .topbar-avatar-initials {\n    font-size: 0.75rem;\n  }\n  .topbar-action-btn {\n    width: 30px;\n    height: 30px;\n    border-radius: 6px;\n  }\n}\n\n/* ════════════════════════════════════════════════════════\n   REST OF ORIGINAL STYLES (unchanged)\n   ════════════════════════════════════════════════════════ */\n\n@media (max-width: 576px) {\n  .toolbar {\n    margin: 0 0.5rem;\n  }\n}\n\n.wrapper-input-box {\n  width: 50%;\n  margin: 0 1rem;\n  padding: 5px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  color: lightgray;\n  border-radius: 40px;\n  border-radius: 8px;\n  background: #fff;\n  transition: all 0.3s ease;\n}\n\n@media (max-width: 576px) {\n  .wrapper-input-box {\n    margin: 0;\n  }\n}\n\n.navbar-profile-pic {\n  width: 2.3rem;\n  height: 2.3rem;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid #999;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.posNavbarIconBox {\n  display: flex;\n  margin-top: 0.5rem;\n}\n\n.icon-color {\n  color: red !important;\n}\n\n.dark .wrapper-input-box {\n  background: #353a50;\n}\n\n.wrapper-input-box:hover {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\n}\n\n.backBtn-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.search-icon {\n  color: lightgray;\n  font-size: 1.2rem;\n  margin: 0 0.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.scan-icon {\n  color: #2954a5;\n  font-size: 1.6rem !important;\n  margin-right: 0.5rem;\n  cursor: pointer;\n}\n\n.dark .scan-icon {\n  color: lightgray;\n}\n\n.search-loader {\n  display: flex;\n  margin: 0 0.5rem;\n}\n\n.search-input {\n  border: none;\n  background-color: transparent;\n  width: 100%;\n  font-size: 0.9rem;\n}\n\n.search-input-new-keyboard-page {\n  border: none;\n  background-color: transparent;\n  width: 100%;\n  font-size: 0.9rem;\n}\n\n.search-input-new-keyboard-page::placeholder {\n  color: #999;\n}\n\n.search-input::placeholder {\n  color: #999;\n}\n\n.scanner-image {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  padding: 2rem;\n  box-shadow: inset 0 0 0px 2rem rgba(0, 0, 0, 0.5);\n}\n\n.dark .search-input {\n  color: #fff !important;\n}\n\n.search-input:focus {\n  outline: none;\n}\n\n.dark .search-input-new-keyboard-page {\n  color: black !important;\n}\n\n.search-input-new-keyboard-page:focus {\n  outline: none;\n}\n\n.clear-icon {\n  color: black;\n  font-size: 1.2rem;\n  margin: 0 0.5rem;\n  cursor: pointer;\n}\n\n.dark .clear-icon {\n  color: #fff;\n}\n\n.wrapper-icons-container {\n  display: flex;\n  align-items: center;\n}\n\n.palleticon {\n  width: 40px !important;\n}\n\n.posContainer {\n  display: flex;\n}\n\n.access-mode-kds-content {\n  padding: 64px 8px 74px;\n  width: 100%;\n}\n\n.access-mode-kds-navbar .posnavbar-bottom-bar {\n  padding-right: 88px;\n}\n\n.access-mode-kds-exit-btn {\n  position: fixed;\n  right: 8px;\n  bottom: 10px;\n  z-index: 1201;\n  font-family: inherit;\n  border: 0;\n  background: transparent;\n}\n\n.access-mode-kds-content .kds-screen-layout {\n  height: calc(100dvh - 138px);\n}\n\n.navbar-disabled-region .topbar-right-actions > .topbar-action-btn,\n.navbar-disabled-region .topbar-theme-toggle-btn,\n.navbar-disabled-region .topbar-notif-bell-wrap,\n.navbar-disabled-region .topbar-avatar-btn,\n.navbar-disabled-region .topbar-brand,\n.navbar-disabled-region .topbar-center,\n.navbar-disabled-region .posnavbar-bottom-bar-right {\n  opacity: 0.5;\n}\n\n.navbar-disabled-region,\n.navbar-disabled-region * {\n  cursor: not-allowed !important;\n}\n\n.navbar-disabled-region [data-kds-navigation-enabled],\n.navbar-disabled-region [data-kds-navigation-enabled] * {\n  cursor: auto !important;\n  opacity: 1;\n}\n\n.navbar-disabled-region button[data-kds-navigation-enabled],\n.navbar-disabled-region [data-kds-navigation-enabled] button,\n.navbar-disabled-region [data-kds-navigation-enabled] .topbar-search-clear {\n  cursor: pointer !important;\n}\n\n.navbar-disabled-region [data-kds-navigation-enabled] input {\n  cursor: text !important;\n}\n\n.posContainerPaddingBottom {\n  padding-bottom: 64px;\n}\n\n@media (max-width: 576px) {\n  .posContainer {\n    flex-direction: column;\n  }\n}\n\n.dark .posContainer {\n  background-color: #2b2f42 !important;\n}\n\n.light .posContainer {\n  background: #ffffff !important;\n}\n\n.posNavbar {\n  justify-content: flex-end;\n}\n\n@media (max-width: 576px) {\n  .posNavbar {\n    justify-content: center;\n  }\n\n  .newpayment-posNabar {\n    justify-content: center;\n  }\n}\n\n.dark .newpayment-posNabar {\n  background-color: #2b2f42 !important;\n  box-shadow: none !important;\n}\n\n.light .newpayment-posNabar {\n  background: #ffffff;\n  color: black;\n  box-shadow: none !important;\n  z-index: 100;\n}\n\n.dark .posNavbar {\n  background-color: #2b2f42 !important;\n  box-shadow: none !important;\n  z-index: 1200;\n}\n\n.light .posNavbar {\n  background: #f5f5f5;\n  color: black;\n  box-shadow: none !important;\n  z-index: 1200;\n}\n\n.dark .css-12i7wg6-MuiPaper-root-MuiDrawer-paper {\n  background-color: #2b2f42;\n  border: none;\n}\n\n.light .css-12i7wg6-MuiPaper-root-MuiDrawer-paper {\n  background: #f5f5f5;\n  border-right: none;\n}\n\n.sideNav1 {\n  height: 100vh !important;\n}\n\n.line {\n  margin: 1rem;\n  opacity: 0.5;\n}\n\n.name-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px !important;\n  background-color: #fff;\n  border-radius: 7px;\n  width: 40%;\n  padding: 0 1rem;\n}\n\n.search-container-box {\n  width: 100vw;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1;\n}\n\n.sideList {\n  background-color: #fff;\n  border-radius: 7px;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  width: 80px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (max-height: 566px) and (max-width: 576px) {\n  .sideList {\n    height: auto;\n    margin-bottom: 1rem !important;\n  }\n}\n\n@media (max-height: 637px) and (min-width: 577px) {\n  .sideList {\n    height: auto;\n    margin-bottom: 1rem !important;\n  }\n}\n\n.dark .sideList {\n  color: #353a50 !important;\n  background-color: #353a50 !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.MuiDrawer-root .MuiDrawer-docked .sideNav1 .css-320yd2-MuiDrawer-docked {\n  background-color: rgb(239, 240, 241) !important;\n}\n\n.home-text-navbar {\n  text-align: center;\n  color: #414552;\n}\n\n.dark .home-text-navbar {\n  text-align: center;\n  color: white;\n}\n\n.css-10hburv-MuiTypography-root {\n  font-size: 0.7em !important;\n  font-weight: 600 !important;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  letter-spacing: 0.1px !important;\n}\n\n.home-text-navbar-III {\n  font-weight: 600 !important;\n  text-align: center;\n  color: red;\n  font-size: 0.7em !important;\n}\n\n.home-text-navbar-IV {\n  font-weight: 600 !important;\n  text-align: center;\n  color: green;\n  font-size: 0.7em !important;\n}\n\n.dark .home-text-navbar-III {\n  text-align: center;\n  color: white;\n}\n\n.home-text-navbar-II {\n  font-weight: 600 !important;\n  text-align: center;\n  color: #000;\n}\n\n.dark .home-text-navbar-I {\n  color: #fff !important;\n}\n\n.css-320yd2-MuiDrawer-docked {\n  width: 80px !important;\n}\n\n.dark .icon {\n  color: #949494;\n}\n\n.light .icon {\n  color: #949494;\n}\n\n.icon-active {\n  color: #0860e6 !important;\n}\n\n.icon-active-dark {\n  color: white !important;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.blinking {\n  animation: blink 1s linear infinite;\n}\n\n.name-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em !important;\n  font-weight: 600 !important;\n}\n\n.home-background-active {\n  border-radius: var(--4, 0.25rem) !important;\n  border: 2px solid var(--Blue-B0, #0860e6) !important;\n  background-color: var(--Blue-B4, #d9f2ff) !important;\n  margin: 10px !important;\n}\n\n.dark .home-background-active {\n  background-color: #0562fb !important;\n}\n\n.power-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.user-active-box {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.user-active-image {\n  width: 10px;\n  height: 10px;\n  object-fit: contain;\n  display: flex;\n  align-items: center;\n}\n\n.active-text {\n  border: 1px solid lightgray;\n  font-weight: 600;\n  font-size: 0.7em;\n  letter-spacing: 0.15em;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 3px;\n}\n\n.full-screen-wrapper {\n  border-radius: 7px !important;\n  border: 1px solid black !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  margin-bottom: 10px !important;\n  gap: 10px !important;\n  width: 100%;\n  padding: 4px !important;\n  cursor: pointer;\n  color: black !important;\n  font-weight: bold !important;\n}\n\n.dark .full-screen-wrapper {\n  color: white !important;\n  border: 1px solid rgb(255, 255, 255) !important;\n}\n\n.full-screen-wrapper:hover {\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 10px 0px;\n}\n\n.modal-description {\n  font-weight: bold !important;\n  font-size: 1em !important;\n  cursor: pointer;\n}\n\n.user-modal-wrapper-box {\n  border: none;\n}\n\n.user-modal-wrapper-box:focus {\n  outline: none;\n}\n\n/* Profile Actions Modal */\n.profile-actions-modal {\n  gap: 2px !important;\n  text-align: left !important;\n  position: absolute !important;\n  top: 60px !important;\n  right: 20px !important;\n  left: auto !important;\n  bottom: auto !important;\n  transform: none !important;\n}\n\n.profile-actions-header {\n  font-size: 0.68rem !important;\n  font-weight: 600 !important;\n  color: #9ca3af !important;\n  letter-spacing: 0.07em !important;\n  text-transform: uppercase !important;\n  padding: 4px 4px 10px 4px !important;\n  width: 100%;\n}\n\n.profile-action-item {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  padding: 9px 8px !important;\n  border-radius: 10px !important;\n  cursor: pointer !important;\n  width: 100% !important;\n  border: none !important;\n  transition: background-color 0.15s ease !important;\n}\n\n.profile-action-item:hover {\n  background-color: #f3f4f6 !important;\n  box-shadow: none !important;\n}\n\n.dark .profile-action-item:hover {\n  background-color: rgba(255, 255, 255, 0.07) !important;\n}\n\n.profile-action-icon-wrap {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f3f4f6;\n}\n\n.profile-action-icon-wrap-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.dark .profile-action-icon-wrap {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.profile-action-icon-wrap.logout {\n  background-color: #fde8e8;\n}\n\n.profile-action-item-title {\n  font-size: 0.875rem !important;\n  font-weight: 600 !important;\n  line-height: 1.3 !important;\n  color: #111827 !important;\n}\n\n.dark .profile-action-item-title {\n  color: #f9fafb !important;\n}\n\n.profile-action-item-subtitle {\n  font-size: 0.72rem !important;\n  font-weight: 400 !important;\n  color: #6b7280 !important;\n  line-height: 1.35 !important;\n  margin-top: 1px;\n}\n\n.dark .profile-action-item-subtitle {\n  color: #9ca3af !important;\n}\n\n.icon-off {\n  color: red !important;\n}\n\n.dark .home-text-navbar-III {\n  color: red !important;\n}\n\n.icon-on {\n  color: green !important;\n}\n\n.customerDiv:disabled {\n  background-color: #dddddd !important;\n  border: 1px solid lightgray;\n  color: darkgray !important;\n  cursor: not-allowed !important;\n}\n\n.click-me-text {\n  color: #2954a5 !important;\n  font-weight: 600 !important;\n  font-size: 28px !important;\n}\n\n.hide-me-btn {\n  width: 0px;\n  height: 0px;\n  border: none;\n  background-color: transparent;\n}\n\n.hide-me-btn:focus {\n  outline: none;\n}\n\n.text-in-modal {\n  text-align: center !important;\n  font-size: 28px !important;\n  font-weight: bold !important;\n  color: red !important;\n  border-radius: 10px !important;\n}\n\n.error-img-barcode {\n  width: 70px !important;\n  height: 70px !important;\n  background-color: red !important;\n}\n\n.modal-main-wrapper-shortcut {\n  border-radius: 10px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  background-color: #f9fafb !important;\n  border: 1px solid #e5e7eb;\n  z-index: 10000;\n  width: 90%;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 1rem 1rem 0 1rem;\n}\n\n.dark .modal-main-wrapper-shortcut {\n  background-color: #353a50 !important;\n}\n\n.close-icon-wrapper-modal {\n  line-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.shortcuts-close-icon {\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.shortcuts-close-icon:hover {\n  background-color: #2954a5;\n  color: #fff;\n}\n\n.modal-popup .MuiBackdrop-root {\n  backdrop-filter: blur(5px);\n}\n\n.backdrop-pos {\n  color: var(--blue);\n  z-index: 1203;\n  backdrop-filter: blur(5px);\n  background-color: rgb(255 255 255 / 0%) !important;\n}\n\n.delivery-tab-status {\n  color: lightgray !important;\n}\n\n.full-screen-wrapper:focus {\n  background-color: #007bff64 !important;\n  opacity: 0.8;\n  border: 2px solid #007bff;\n  border-radius: 5px;\n  transition:\n    background-color 0.3s ease,\n    opacity 0.3s ease,\n    border-color 0.3s ease;\n  outline: none;\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.blinking::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 70%;\n  height: 100%;\n  margin-left: 15%;\n  border-radius: 4px;\n  background-color: rgba(255, 165, 0, 0.5);\n  animation: blink 1.5s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.new-pos-header {\n  background-color: white;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 1rem;\n  margin-top: 1rem;\n  padding: 10px;\n  border-radius: 0.5rem;\n}\n\n.new-pos-header.dark {\n  background-color: var(--dark-blue);\n}\n\n.pos-header-text {\n  color: #333;\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 100%;\n}\n\n.pos-header-text.dark {\n  color: var(--surface-white);\n}\n\n.common-search-bar-2 {\n  width: 60%;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background-color: #f5f5f5 !important;\n  padding: 0 5px;\n  border-radius: 0.5rem;\n  border: none;\n}\n\n.common-search-bar-2.dark {\n  background-color: var(--dark-blue) !important;\n  border: 1px solid var(--dark-background);\n}\n\n.normal-flex-searchbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 70%;\n  gap: 1rem;\n}\n\n.mobile-normal-flex-searchbar {\n  width: 100%;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.new-mobile-searchbar-div {\n  margin-top: 0.5rem;\n}\n\n.disableIcon {\n  color: #e5e5e5 !important;\n}\n\n.new-pos-header-inner {\n  display: flex;\n  gap: 8px;\n}\n\n.commonSearchbarContainer {\n  width: 50%;\n}\n\n/* ════════════════════════════════════════════════════════\n   BOTTOM NAV BAR\n   ════════════════════════════════════════════════════════ */\n\n.posnavbar-bottom-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #ffffff;\n  border-top: 1px solid #e9eaeb;\n  padding: 0 8px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1200;\n  height: 66px;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.dark .posnavbar-bottom-bar {\n  background-color: #2b2f42;\n  border-top-color: rgba(255, 255, 255, 0.1);\n}\n\n.posnavbar-bottom-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.posnavbar-bottom-bar-left::-webkit-scrollbar {\n  display: none;\n}\n\n.posnavbar-bottom-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  padding-left: 8px;\n  border-left: 1px solid #e9eaeb;\n}\n\n.dark .posnavbar-bottom-bar-right {\n  border-left-color: rgba(255, 255, 255, 0.1);\n}\n\n.posnavbar-cart-bar-portal {\n  display: flex;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.posnavbar-cart-bar-portal .cartGrossAndActionRow {\n  flex: 1;\n  border-top: none;\n  background: transparent;\n  padding: 0 8px;\n}\n\n.posnavbar-bottom-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #717680;\n  transition:\n    background-color 0.15s,\n    color 0.15s;\n  min-width: 64px;\n  flex-shrink: 0;\n  gap: 4px;\n}\n\n.posnavbar-bottom-btn:hover {\n  background-color: #f5f5f5;\n  color: #252b37;\n}\n\n.posnavbar-bottom-btn:active {\n  background-color: #eeeeee;\n}\n\n.posnavbar-bottom-btn-active {\n  color: #0860e6 !important;\n  background-color: #d9f2ff !important;\n  border-radius: 10px;\n}\n\n.dark .posnavbar-bottom-btn {\n  color: #949494;\n}\n\n.dark .posnavbar-bottom-btn:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: #ffffff;\n}\n\n.dark .posnavbar-bottom-btn-active {\n  color: #ffffff !important;\n  background-color: #0562fb !important;\n}\n\n.posnavbar-bottom-btn-icon-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n}\n\n.posnavbar-notif-dot {\n  position: absolute;\n  top: -3px;\n  right: -4px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #f44336;\n  border: 1.5px solid #ffffff;\n  animation: blink 1s linear infinite;\n}\n\n.dark .posnavbar-notif-dot {\n  border-color: #2b2f42;\n}\n\n.posnavbar-bottom-btn-label {\n  font-size: 10px;\n  font-weight: 500;\n  margin-top: 2px;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.posnavbar-bottom-btn-logout {\n  color: #c62828;\n}\n\n.posnavbar-bottom-btn-logout:hover {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.posnavbar-printer-status {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 8px;\n  gap: 2px;\n}\n\n.posnavbar-printer-icon-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #717680;\n}\n\n.posnavbar-printer-dot {\n  position: absolute;\n  top: -3px;\n  right: -3px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 1.5px solid white;\n}\n\n.posnavbar-printer-dot-online {\n  background-color: #4caf50;\n}\n\n.posnavbar-printer-dot-offline {\n  background-color: #f44336;\n}\n\n.posnavbar-printer-label-online {\n  font-size: 10px;\n  font-weight: 500;\n  color: #2e7d32;\n  white-space: nowrap;\n}\n\n.posnavbar-printer-label-offline {\n  font-size: 10px;\n  font-weight: 500;\n  color: #c62828;\n  white-space: nowrap;\n}\n\n/* ── No-session logout button (replaces weather widget) ── */\n.posnavbar-logout-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 8px;\n  gap: 2px;\n  cursor: pointer;\n  color: #c62828;\n  transition: background-color 0.15s;\n}\n\n.posnavbar-logout-btn:hover {\n  background-color: #ffebee;\n}\n\n.posnavbar-logout-label {\n  font-size: 10px;\n  font-weight: 500;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.dark .posnavbar-logout-btn {\n  color: #ef9a9a;\n}\n\n.dark .posnavbar-logout-btn:hover {\n  background-color: rgba(198, 40, 40, 0.15);\n}\n\n/* ── EDC machine status indicator ── */\n.posnavbar-payment-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  color: inherit;\n  cursor: default;\n  flex-shrink: 0;\n}\n\n.posnavbar-wifi-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border-radius: 8px;\n  color: inherit;\n  cursor: default;\n  flex-shrink: 0;\n}\n\n.posnavbar-payment-btn--clickable {\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.posnavbar-payment-btn--clickable:hover { background: rgba(255,255,255,0.08); }\n\n/* ── No Internet Overlay ── */\n.net-offline-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  background: #0a0a0a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: netFadeIn 0.35s ease;\n}\n\n@keyframes netFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.net-offline-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: 400px;\n  padding: 0 24px;\n  animation: netSlideUp 0.4s cubic-bezier(.22,.61,.36,1);\n}\n\n@keyframes netSlideUp {\n  from { transform: translateY(28px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n.net-offline-icon-ring {\n  width: 88px;\n  height: 88px;\n  border-radius: 50%;\n  background: #1a1a1a;\n  border: 2px solid #2a2a2a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 28px;\n  box-shadow: 0 0 0 16px rgba(255,255,255,0.03);\n}\n\n.net-offline-title {\n  font-size: 1.6rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin: 0 0 12px;\n  letter-spacing: -0.01em;\n}\n\n.net-offline-sub {\n  font-size: 0.92rem;\n  color: #888;\n  line-height: 1.6;\n  margin: 0 0 24px;\n}\n\n.net-offline-pills {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 32px;\n}\n\n.net-offline-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid #2a2a2a;\n  color: #aaa;\n  font-size: 0.78rem;\n  font-weight: 500;\n  background: #141414;\n}\n\n.net-offline-retry {\n  width: 100%;\n  max-width: 240px;\n  padding: 14px;\n  border-radius: 6px;\n  border: none;\n  background: #e50914;\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.03em;\n  transition: background 0.15s, transform 0.1s;\n  margin-bottom: 20px;\n}\n.net-offline-retry:hover  { background: #f40612; }\n.net-offline-retry:active { transform: scale(0.97); }\n\n.net-offline-footnote {\n  font-size: 0.75rem;\n  color: #555;\n  margin: 0;\n}\n\n/* ── Slow Internet Toast ── */\n.net-slow-toast {\n  position: fixed;\n  bottom: 80px;\n  left: 20px;\n  z-index: 99998;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  background: #1c1400;\n  border: 1px solid #f59e0b40;\n  border-left: 3px solid #f59e0b;\n  border-radius: 12px;\n  padding: 14px 16px;\n  min-width: 300px;\n  max-width: 380px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.35);\n  animation: netToastIn 0.4s cubic-bezier(.22,.61,.36,1);\n}\n\n@keyframes netToastIn {\n  from { transform: translateX(-24px); opacity: 0; }\n  to   { transform: translateX(0);     opacity: 1; }\n}\n\n.net-slow-icon {\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: rgba(245,158,11,0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f59e0b;\n  margin-top: 2px;\n}\n\n.net-slow-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.net-slow-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.net-slow-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n.net-slow-speed {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #f59e0b;\n  background: rgba(245,158,11,0.12);\n  padding: 2px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.net-slow-sub {\n  font-size: 0.77rem;\n  color: #a16207;\n  line-height: 1.45;\n  margin: 0 0 10px;\n}\n.dark .net-slow-sub { color: #92400e; }\n\n.net-slow-progress-track {\n  width: 100%;\n  height: 3px;\n  border-radius: 999px;\n  background: rgba(245,158,11,0.15);\n  overflow: hidden;\n}\n\n.net-slow-progress-bar {\n  height: 100%;\n  background: #f59e0b;\n  border-radius: 999px;\n  animation: netSlowProgress 8s linear forwards;\n}\n\n@keyframes netSlowProgress {\n  from { width: 100%; }\n  to   { width: 0%; }\n}\n\n.net-slow-close {\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(245,158,11,0.12);\n  color: #f59e0b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n  margin-top: 2px;\n  padding: 0;\n}\n.net-slow-close:hover { background: rgba(245,158,11,0.22); }\n\n/* ── EDC Mode Toggle Modal ── */\n.edc-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  backdrop-filter: blur(3px);\n}\n\n.edc-modal-card {\n  background: #ffffff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 420px;\n  padding: 28px;\n  position: relative;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.22);\n}\n\n.dark .edc-modal-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n}\n\n.edc-modal-close-btn {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #64748b;\n  transition: background 0.15s;\n}\n.edc-modal-close-btn:hover { background: #f1f5f9; }\n.dark .edc-modal-close-btn { background: #334155; border-color: #475569; color: #94a3b8; }\n\n.edc-modal-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.edc-modal-lock-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(96, 165, 250, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.edc-modal-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n.dark .edc-modal-title { color: #f1f5f9; }\n\n.edc-modal-subtitle {\n  font-size: 0.82rem;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.4;\n}\n.dark .edc-modal-subtitle { color: #94a3b8; }\n\n.edc-modal-body form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.edc-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.edc-modal-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.dark .edc-modal-label { color: #94a3b8; }\n\n.edc-modal-pin-wrap {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 4px 12px;\n  background: #f8fafc;\n}\n.dark .edc-modal-pin-wrap {\n  background: #0f172a;\n  border-color: #334155;\n}\n.edc-modal-pin-wrap .MuiInput-root { width: 100%; }\n.edc-modal-pin-wrap input { color: #1e293b; font-weight: 600; font-size: 0.95rem; }\n.dark .edc-modal-pin-wrap input { color: #f1f5f9; }\n\n.edc-modal-confirm-btn {\n  width: 100%;\n  padding: 12px;\n  border-radius: 10px;\n  border: none;\n  background: #0f172a;\n  color: #f8fafc;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n  margin-top: 4px;\n}\n.edc-modal-confirm-btn:hover { background: #1e293b; }\n.edc-modal-confirm-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.dark .edc-modal-confirm-btn { background: #3b82f6; }\n.dark .edc-modal-confirm-btn:hover { background: #2563eb; }\n\n.edc-modal-cancel-btn {\n  width: 100%;\n  padding: 10px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: transparent;\n  color: #64748b;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.edc-modal-cancel-btn:hover { background: #f8fafc; }\n.dark .edc-modal-cancel-btn { border-color: #334155; color: #94a3b8; }\n.dark .edc-modal-cancel-btn:hover { background: #334155; }\n\n/* ── Location / weather widget ── */\n.posnavbar-location-widget {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  border-radius: 12px;\n  border: none;\n  background: #0f172a;\n  color: #ffffff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  max-width: 160px;\n}\n\n.posnavbar-location-widget:hover {\n  background: #1e293b;\n}\n\n.dark .posnavbar-location-widget {\n  background: #0f172a;\n}\n\n.posnavbar-location-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.posnavbar-location-city {\n  font-size: 11px;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .posnavbar-location-city {\n  color: #d1d5db;\n}\n\n/* ── active state for stats icon button ── */\n.topbar-action-btn--active {\n  background: #eff6ff !important;\n  color: #1a56db !important;\n  border-color: #bfdbfe !important;\n}\n\n/* ════════════════════════════════════════\n   Floor Capacity Popup\n   ════════════════════════════════════════ */\n.fcp-popup {\n  position: absolute;\n  top: calc(100% + 10px);\n  right: 0;\n  width: 300px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.12),\n    0 2px 8px rgba(0, 0, 0, 0.06);\n  padding: 20px;\n  z-index: 9999;\n  border: 1px solid #f0f1f3;\n}\n\n.fcp-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.fcp-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fcp-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #9ca3af;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.fcp-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.fcp-pct-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #eff6ff;\n  border: 1.5px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 6px 12px;\n  min-width: 60px;\n}\n\n.fcp-pct-now {\n  font-size: 9px;\n  font-weight: 700;\n  color: #1a56db;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.fcp-pct-value {\n  font-size: 20px;\n  font-weight: 800;\n  color: #1a56db;\n  line-height: 1.1;\n}\n\n.fcp-bar-track {\n  width: 100%;\n  height: 6px;\n  background: #e5e7eb;\n  border-radius: 99px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.fcp-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6 0%, #1a56db 100%);\n  border-radius: 99px;\n  transition: width 0.4s ease;\n  min-width: 4px;\n}\n\n.fcp-stats-row {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.fcp-stat-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.fcp-stat-label {\n  font-size: 9px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.fcp-stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.1;\n}\n\n.fcp-toggle-row {\n  display: flex;\n  gap: 0;\n  background: #f3f4f6;\n  border-radius: 10px;\n  padding: 3px;\n}\n\n.fcp-toggle-btn {\n  flex: 1;\n  padding: 8px 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #6b7280;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    box-shadow 0.15s;\n}\n\n.fcp-toggle-btn.active {\n  background: #ffffff;\n  color: #1a56db;\n  font-weight: 600;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.fcp-toggle-btn:not(.active):hover {\n  color: #374151;\n}\n\n/* Backdrop */\n.Confirmation___modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n/* Modal Box */\n.Confirmation___modal-container {\n  width: 380px;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 24px 20px;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);\n  animation: confirmationFadeIn 0.2s ease;\n  text-align: center;\n}\n\n/* Title */\n.Confirmation___modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 10px;\n}\n\n/* Text */\n.Confirmation___modal-text {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n/* Actions */\n.Confirmation___modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n/* Buttons */\n.Confirmation___modal-btn {\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n/* Close Button */\n.Confirmation___modal-btn-close {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.Confirmation___modal-btn-close:hover {\n  background: #e5e7eb;\n}\n\n/* Primary Button */\n.Confirmation___modal-btn-primary {\n  background: #16a34a;\n  color: #ffffff;\n}\n\n.Confirmation___modal-btn-primary:hover {\n  background: #15803d;\n}\n\n/* Animation */\n@keyframes confirmationFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ═══ DARK THEME — posnavbar additions ═══ */\n.dark .home-text-navbar-II { color: #f1f5f9 !important; }\n\n/* Floor-Capacity Popup */\n.dark .fcp-popup {\n  background: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3);\n}\n.dark .fcp-label  { color: #64748b; }\n.dark .fcp-title  { color: #f1f5f9; }\n.dark .fcp-pct-badge { background: rgba(42,113,255,0.15); border-color: #1e40af; }\n.dark .fcp-pct-now   { color: #60a5fa; }\n.dark .fcp-pct-value { color: #60a5fa; }\n.dark .fcp-bar-track { background: #334155; }\n.dark .fcp-stat-box  { background: #0f172a; border-color: #334155; }\n.dark .fcp-stat-label { color: #64748b; }\n.dark .fcp-stat-value { color: #f1f5f9; }\n.dark .fcp-toggle-row { background: #0f172a; }\n.dark .fcp-toggle-btn { color: #64748b; }\n.dark .fcp-toggle-btn.active { background: #1e293b; color: #60a5fa; }\n.dark .fcp-toggle-btn:not(.active):hover { color: #94a3b8; }\n\n/* Confirmation modal */\n.dark .Confirmation___modal-container {\n  background: #1e293b;\n  box-shadow: 0px 10px 30px rgba(0,0,0,0.5);\n}\n.dark .Confirmation___modal-title { color: #f1f5f9; }\n.dark .Confirmation___modal-text  { color: #94a3b8; }\n.dark .Confirmation___modal-btn-close {\n  background: #334155;\n  color: #e2e8f0;\n}\n.dark .Confirmation___modal-btn-close:hover { background: #475569; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
